// extracted by mini-css-extract-plugin
export var container = "DeleteMetricaAccount-module--container--1vJb2";
export var error = "DeleteMetricaAccount-module--error--3BAHh";